module.exports = __webpack_public_path__ + "ba01ec0fb172b31ee677774a26adbedb.jpg";